import React, { PureComponent } from 'react';
import Radium from 'radium';
import { arrayOf, string } from 'prop-types';
import Card from 'react-credit-cards';
import { TextField, MuiThemeProvider } from '@material-ui/core';
import { shouldShowErrors } from '@widergy/web-utils/lib/form';
import 'react-credit-cards/es/styles-compiled.css';

import { inputPropTypes, metaPropTypes } from 'types/formTypes';
import { message, replaceWithCircle } from 'utils/stringUtils';

import styles, { theme } from './styles';
import { fields, mapFormatToField } from './constants';

const parseErrors = error => {
  try {
    return JSON.parse(error);
  } catch (e) {
    return null;
  }
};

class UTCreditCard extends PureComponent {
  mapNameField = {
    [fields.NUMBER]: this.props.childKeys[0],
    [fields.NAME]: this.props.childKeys[1],
    [fields.CVC]: this.props.childKeys[2]
  };

  state = { focused: '', values: {} };

  handleChange = name => event => {
    const { value } = event.target;
    const valuesFormat = {
      [this.props.childKeys[0]]: '',
      [this.props.childKeys[1]]: '',
      [this.props.childKeys[2]]: '',
      [this.props.childKeys[3]]: '',
      [this.props.childKeys[4]]: ''
    };
    const formatedValue =
      name === fields.CVC
        ? mapFormatToField[name](value, this.state.values.number)
        : mapFormatToField[name](value);
    this.setState(prevState => ({ values: { ...prevState.values, [name]: formatedValue } }));

    const finalValue =
      name !== fields.EXPIRY
        ? { [this.mapNameField[name]]: formatedValue }
        : {
            [this.props.childKeys[3]]: formatedValue.substring(0, 2),
            [this.props.childKeys[4]]: `20${formatedValue.substring(3, 5)}`
          };

    this.props.input.onChange({ ...valuesFormat, ...this.props.input.value, ...finalValue });
  };

  handleInputFocus = ({ target }) => this.setState({ focused: target.name });

  render() {
    const errors = parseErrors(this.props.meta.error);
    return (
      <div style={[styles.container, this.props.style]}>
        <Card
          number={this.state.values.number || ''}
          name={this.state.values.name}
          expiry={this.state.values.expiry}
          cvc={this.state.values.cvc && replaceWithCircle(this.state.values.cvc)}
          focused={this.state.focused}
          placeholders={{ name: message('CreditCard:yourName') }}
          locale={{ valid: message('CreditCard:expDate') }}
        />
        <MuiThemeProvider theme={theme}>
          <div style={styles.fields}>
            <TextField
              name={fields.NUMBER}
              label={message('CreditCard:cardNumber')}
              onFocus={this.handleInputFocus}
              onChange={this.handleChange(fields.NUMBER)}
              value={this.state.values.number}
              error={shouldShowErrors(this.props.meta) && !!errors.cardNumber}
              fullWidth
              margin="none"
              helperText={(shouldShowErrors(this.props.meta) && errors.cardNumber) || ''}
            />
            <TextField
              name={fields.NAME}
              label={message('CreditCard:holderName')}
              onFocus={this.handleInputFocus}
              onChange={this.handleChange(fields.NAME)}
              value={this.state.values.name}
              error={shouldShowErrors(this.props.meta) && !!errors.holderName}
              fullWidth
              type="text"
              margin="none"
              style={styles.field}
              helperText={(shouldShowErrors(this.props.meta) && errors.holderName) || ''}
            />
            <div style={styles.row}>
              <TextField
                name={fields.EXPIRY}
                label={message('CreditCard:expiry')}
                onFocus={this.handleInputFocus}
                onChange={this.handleChange(fields.EXPIRY)}
                value={this.state.values.expiry}
                error={shouldShowErrors(this.props.meta) && !!errors.expires}
                fullWidth
                margin="none"
                style={styles.minField}
                helperText={(shouldShowErrors(this.props.meta) && errors.expires) || ''}
              />
              <TextField
                name={fields.CVC}
                type="password"
                label={message('CreditCard:cvc')}
                onFocus={this.handleInputFocus}
                onChange={this.handleChange(fields.CVC)}
                value={this.state.values.cvc}
                fullWidth
                error={shouldShowErrors(this.props.meta) && !!errors.securityCode}
                margin="none"
                style={styles.minField}
                helperText={(shouldShowErrors(this.props.meta) && errors.securityCode) || ''}
              />
            </div>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

UTCreditCard.propTypes = {
  input: inputPropTypes.isRequired,
  meta: metaPropTypes.isRequired,
  childKeys: arrayOf(string)
};

export default Radium(UTCreditCard);
